import {SVG} from '../../../../../constants/assetLists';

type Props = {show: boolean; text?: string};

function OnboardingValidationBadge({show, text = 'השלם את הנתונים'}: Props) {
  if (!show) return null;

  return (
    <div
      className="flex bg-[#FFE1F3] items-center justify-center px-[8px] py-[4px] gap-2 rounded-md shrink-0"
      role="alert">
      <img
        src={SVG.validationErrorOnboarding}
        alt="icon"
        className="w-[24px] h-[24px] object-contain shrink-0"
      />
      <span className="text-[14px] font-medium text-[#E52055]">{text}</span>
    </div>
  );
}

export default OnboardingValidationBadge;
